import { Star } from "lucide-react";
import { Alert, AlertTitle } from "@/components/ui/alert";

export function VipMemberBanner() {
    return (
        // The banner is a permanent marker rather than a notification, so it
        // must not be announced like an alert whenever the profile opens.
        <Alert
            role="status"
            className="shrink-0 items-center rounded-none border-amber-200 border-x-0 border-t-0 bg-amber-50 text-amber-950"
        >
            <Star
                aria-hidden
                className="size-4 shrink-0 fill-amber-400 text-amber-500"
            />
            <AlertTitle>VIP member</AlertTitle>
        </Alert>
    );
}
